// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let IconV5 = require("../../uikit/atoms/Icon/IconV5.bs.js");
let DialogV5 = require("../../uikit/reason/molecules/Dialog/DialogV5.bs.js");
let ShareURLMakers = require("./ShareURLMakers.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let VisuallyHidden = require("@reach/visually-hidden").default;
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let CopyMarketingProfileLinkButton = require("./CopyMarketingProfileLinkButton.bs.js");
let ShareAgentMarketingProfileDialog_agentMarketingProfile_graphql = require("../../__generated__/ShareAgentMarketingProfileDialog_agentMarketingProfile_graphql.bs.js");

let convertFragment = ShareAgentMarketingProfileDialog_agentMarketingProfile_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ShareAgentMarketingProfileDialog_agentMarketingProfile_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(ShareAgentMarketingProfileDialog_agentMarketingProfile_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, ShareAgentMarketingProfileDialog_agentMarketingProfile_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(ShareAgentMarketingProfileDialog_agentMarketingProfile_graphql.node, convertFragment, fRef);
}

let Fragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function ShareAgentMarketingProfileDialog$BaseShareLink(props) {
  return JsxRuntime.jsxs("a", {
    children: [
      JsxRuntime.jsx("div", {
        children: props.children,
        className: "flex gap-4"
      }),
      JsxRuntime.jsx(IconV5.make, {
        icon: "arrow-right",
        className: "ml-2"
      })
    ],
    className: "flex justify-between py-4 px-3 hover:bg-zinc-100 rounded-lg text-zinc-700 hover:text-zinc-700 font-semibold",
    href: props.href,
    rel: "noopener noreferrer",
    target: "_blank"
  });
}

let BaseShareLink = {
  make: ShareAgentMarketingProfileDialog$BaseShareLink
};

function ShareAgentMarketingProfileDialog$ShareOnFacebook(props) {
  return JsxRuntime.jsx(ShareAgentMarketingProfileDialog$BaseShareLink, {
    href: ShareURLMakers.makeFacebookShareUrl(props.url),
    children: JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsx(IconV5.make, {
          icon: "facebook",
          className: "text-blue-600 h-5 w-5"
        }),
        "Share on Facebook"
      ],
      className: "flex gap-4"
    })
  });
}

let ShareOnFacebook = {
  make: ShareAgentMarketingProfileDialog$ShareOnFacebook
};

function ShareAgentMarketingProfileDialog$ShareOnTwitter(props) {
  return JsxRuntime.jsx(ShareAgentMarketingProfileDialog$BaseShareLink, {
    href: ShareURLMakers.makeTwitterShareUrl(props.url),
    children: JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsx(IconV5.make, {
          icon: "twitter",
          className: "text-blue-400 w-5 h-5"
        }),
        "Share on Twitter"
      ],
      className: "flex gap-4"
    })
  });
}

let ShareOnTwitter = {
  make: ShareAgentMarketingProfileDialog$ShareOnTwitter
};

function makeLinkedInShareUrl(url) {
  return "https://www.linkedin.com/shareArticle?mini=true&url=" + ShareURLMakers.encodeUrl(url);
}

function ShareAgentMarketingProfileDialog$ShareOnLinkedIn(props) {
  return JsxRuntime.jsx(ShareAgentMarketingProfileDialog$BaseShareLink, {
    href: "https://www.linkedin.com/shareArticle?mini=true&url=" + ShareURLMakers.encodeUrl(props.url),
    children: JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsx(IconV5.make, {
          icon: "linked-in",
          className: "text-blue-600 w-5 h-5"
        }),
        "Share on LinkedIn"
      ],
      className: "flex gap-4"
    })
  });
}

let ShareOnLinkedIn = {
  makeLinkedInShareUrl: makeLinkedInShareUrl,
  make: ShareAgentMarketingProfileDialog$ShareOnLinkedIn
};

function ShareAgentMarketingProfileDialog$ShareViaEmail(props) {
  return JsxRuntime.jsx(ShareAgentMarketingProfileDialog$BaseShareLink, {
    href: ShareURLMakers.makeEmailShareUrl(props.url),
    children: JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsx(IconV5.make, {
          icon: "email",
          className: "text-zinc-500 w-5 h-5"
        }),
        "Share via email"
      ],
      className: "flex gap-4"
    })
  });
}

let ShareViaEmail = {
  make: ShareAgentMarketingProfileDialog$ShareViaEmail
};

function ShareAgentMarketingProfileDialog$CloseButton(props) {
  let onPress = props.onPress;
  return JsxRuntime.jsxs("button", {
    children: [
      JsxRuntime.jsx(VisuallyHidden, {
        children: "Close"
      }),
      JsxRuntime.jsx("span", {
        children: JsxRuntime.jsx(IconV5.make, {
          icon: "cancel",
          size: 12
        }),
        "aria-hidden": true,
        className: "flex"
      })
    ],
    className: "border-transparent border cursor-pointer rounded-full p-3 hover:border-zinc-100 hover:bg-zinc-100 text-zinc-500 absolute right-4",
    onClick: param => onPress()
  });
}

let CloseButton = {
  make: ShareAgentMarketingProfileDialog$CloseButton
};

function ShareAgentMarketingProfileDialog(props) {
  let onDismiss = props.onDismiss;
  let marketingProfile = RescriptRelay_Fragment.useFragment(ShareAgentMarketingProfileDialog_agentMarketingProfile_graphql.node, convertFragment, props.marketingProfile);
  return JsxRuntime.jsx(DialogV5.make, {
    isOpen: props.isOpen,
    ariaLabel: "Share profile",
    onDismiss: onDismiss,
    size: "XLarge",
    showCloseButton: true,
    children: JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsx(ShareAgentMarketingProfileDialog$CloseButton, {
          onPress: onDismiss
        }),
        JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx("div", {
              children: "Share your marketing profile",
              className: "text-center font-semibold text-lg text-zinc-800"
            }),
            JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx(ShareAgentMarketingProfileDialog$ShareOnFacebook, {
                  url: marketingProfile.publicUrl
                }),
                JsxRuntime.jsx(ShareAgentMarketingProfileDialog$ShareOnTwitter, {
                  url: marketingProfile.publicUrl
                }),
                JsxRuntime.jsx(ShareAgentMarketingProfileDialog$ShareOnLinkedIn, {
                  url: marketingProfile.publicUrl
                }),
                JsxRuntime.jsx(ShareAgentMarketingProfileDialog$ShareViaEmail, {
                  url: marketingProfile.publicUrl
                })
              ]
            }),
            JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx(CopyMarketingProfileLinkButton.make, {
                urlDetails: marketingProfile.urlDetails.fragmentRefs
              }),
              className: "lg:px-4"
            })
          ],
          className: "flex flex-col gap-6"
        })
      ]
    })
  });
}

let make = ShareAgentMarketingProfileDialog;

exports.Fragment = Fragment;
exports.BaseShareLink = BaseShareLink;
exports.ShareOnFacebook = ShareOnFacebook;
exports.ShareOnTwitter = ShareOnTwitter;
exports.ShareOnLinkedIn = ShareOnLinkedIn;
exports.ShareViaEmail = ShareViaEmail;
exports.CloseButton = CloseButton;
exports.make = make;
/* IconV5 Not a pure module */
